module.exports = __webpack_public_path__ + "img/icon-average-eletric-consumption.9da22eed.svg";